import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col, Alert } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Swal from "sweetalert2";
import api from "../../../../utils/api";
import { fetchClientData } from "../../../../redux/client/clientSlice";
import UploadNomineeDocument from "../../../Modals/UploadNomineeDocument";

const relationshipMap = {
  SPOUSE: "20",
  //   HUSBAND: "20",
  //   WIFE: "20",
  //   SP: "20",
  MOTHER: "13",
  //   DAUGHTER_IN_LAW: "05",
  //   BROTHER_IN_LAW: "02",
  //   FATHER_IN_LAW: "07",
  //   SON_IN_LAW: "19",
  //   GRANDSON: "11",
  //   GRANDDAUGHTER: "08",
  //   SISTER_IN_LAW: "17",
  FATHER: "06",
  NEPHEW: "14",
  //   FIANCEE: "22",
  //   FRIEND: "22",
  //   COUSIN: "22",
  //   UNCLE: "21",
  //   NEICE: "15",
  DAUGHTER: "04",
  SISTER: "16",
  SON: "18",
  BROTHER: "03",
};

const NomineeDetailsDraft = ({
  onSkip,
  show,
  nomineeAuthenticationModalData,
  onHide,
  proofType,
  roomId,
  clientData,
  setAlertMessage,
  alertMessage,
}) => {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();

  const [dob, setDob] = useState(null);
  const [age, setAge] = useState(0);


    const [optNominee, setOptNominee] = useState("yes");
    const [uploadedFile, setUploadedFile] = useState(null);

  // ✅ Age calculate
  useEffect(() => {
    if (dob) {
      const today = new Date();
      const birthDate = new Date(dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      setAge(age);
    }
  }, [dob]);

  // ✅ Pre-fill data
  useEffect(() => {
    const data = nomineeAuthenticationModalData;
    console.log('nomineeAuthenticationModalData', data);

    if (data) {

      const fields = {
        ClientCode: data.ClientCode || data.clientCode || "",
        Nom1_Name: data.Nom1_Name || data.name || "",
        Nom1_Relationship: data.Nom1_Relationship || data.relationship || "",
        Nom1_App_Percent: data.Nom1_App_Percent || data.applicable || "",
        Nom1_IdType: data.Nom1_IdType || data.idType || "",
        Nom1_IdNo: data.Nom1_IdNo || data.idNo || "",
        Nom1_Email: data.Nom1_Email || data.email || "",
        Nom1_MobileNo: data.Nom1_MobileNo || data.mobile || "",
        Nom1_Add1: data.address || "",
        Nom1_Add2: data.address || "",
        Nom1_City: data.Nom1_City || data.city || "",
        Nom1_Pincode: data.Nom1_Pincode || data.pincode || "",
        Nom1_Country: data.Nom1_Country || data.country || "",
      };

      Object.entries(fields).forEach(([field, value]) => setValue(field, value));
      if (data.Nom1_DOB) {
        const parsed = moment(data.Nom1_DOB);
        if (parsed.isValid()) {
          setDob(parsed.toDate());
          setValue("Nom1_DOB", data.Nom1_DOB);
        }
      }
    }
  }, [nomineeAuthenticationModalData, setValue]);



  const onSubmit = async (formData) => {
    console.log("Final Payload", formData);

    const mappedRelation =
      relationshipMap[formData.Nom1_Relationship?.toUpperCase()] ||
      formData.Nom1_Relationship;

    // ✅ ID Type ko map karo
    const mappedIdType = idTypeMap[formData.Nom1_IdType?.toUpperCase()] || formData.Nom1_IdType;

    const payload = {
      ...formData,
      // Nom1_App_Percent: 100,
      // Nom1_Country: 'India',
      Nom1_Relationship: mappedRelation,
      Nom1_IdType: mappedIdType, // 👈 ye change
      Nom1_DOB: dob ? moment(dob).format("YYYY-MM-DD") : "",
    };

    console.log("Final Payload", payload, formData);

    try {
      Swal.fire({
        text: "Please wait...",
        imageUrl: "https://www.finedge.in/assets/images/download.gif",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      const response = await api.post(`advisor/register-nominee`, payload);

      // ✅ Success/Error handle
      if (response.data?.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.data?.message || "Nominee registered successfully",
          confirmButtonText: "OK",
        }).then(() => {
          reset();
          onHide();
          dispatch(fetchClientData(roomId));
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Upload Failed",
          text:
            response.data?.response?.ErrorMessage?.[0]?.ErrRemarks ||
            response.data?.message ||
            "Something went wrong!",
        });
      }
    } catch (error) {
      console.error("Error registering nominee:", error);
      setAlertMessage({
        visible: true,
        message:
          error.response?.data?.response?.ErrorMessage?.[0]?.ErrRemarks ||
          error.response?.data?.message ||
          "An error occurred while registering nominee. Please try again.",
        variant: "danger",
      });
    }
  };

  const idTypeMap = {
    PAN: "1",
    AADHAR: "2",
    DL: "3",
    PASSPORT: "4",
  };


  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton style={{ backgroundColor: "#c7e69b" }}>
        <Modal.Title>Update Nominee 1 Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {alertMessage.visible && (
            <Alert
              variant={alertMessage.variant}
              onClose={() =>
                setAlertMessage({ ...alertMessage, visible: false })
              }
              dismissible
            >
              {alertMessage.message}
            </Alert>
          )}
          <p className="fs-21 fw-bold">Do you want to opt for nominee?</p>
          <Row className="mb-3">
            <Col>
              <Form.Check
                type="radio"
                label="Yes"
                value="yes"
                checked={optNominee === "yes"}
                onChange={() => setOptNominee("yes")}
              />
            </Col>

            <Col>
              <Form.Check
                type="radio"
                label="No"
                value="no"
                checked={optNominee === "no"}
                onChange={() => setOptNominee("no")}
              />
            </Col>
          </Row>
          {optNominee === "no" && (
            <>
              <div className="p-2 bg-light">
                <p className="mb-1 fw-semibold">Download Declaration Document</p>

                <a
                  href="/assets/images/Annexure-II.pdf"
                  download="Annexure-II.pdf"   // ⬅ forces download
                  className="btn btn-outline-success btn-sm"
                >
                  ⬇ Download (PDF)
                </a>
              </div>


              <UploadNomineeDocument onFileSelect={setUploadedFile} roomId={roomId} />

              <Modal.Footer className="border-0 mt-3">
                {/* <Button variant="secondary" onClick={onHide}>Close</Button>
                <Button variant="success" onClick={() => console.log("Upload File:", uploadedFile)}>
                  Upload Document
                </Button> */}
              </Modal.Footer>
            </>

          )}
          {optNominee === "yes" && (
            <>
              {/* Row 1: UCC, Name, Relationship, Applicable %, Mobile */}
              <Row className="mb-3">
                <Col md={2}>
                  <Form.Group controlId="ClientCode">
                    <Form.Label style={{ whiteSpace: "nowrap" }}>UCC (Client Code)</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("ClientCode", { required: "UCC is required" })}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="Nom1_Name">
                    <Form.Label style={{ marginLeft: 8 }}>Name</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("Nom1_Name", { required: "Name is required" })}
                    />
                  </Form.Group>
                </Col>

                <Col md={2}>
                  <Form.Group controlId="Nom1_Relationship">
                    <Form.Label>Relationship</Form.Label>
                    <Form.Control
                      as="select"
                      {...register("Nom1_Relationship", { required: "Relationship is required" })}
                    >
                      <option value="">Select</option>
                      {Object.keys(relationshipMap).map((label) => (
                        <option key={label} value={label}>
                          {label.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase())}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={2}>
                  <Form.Group controlId="Nom1_App_Percent">
                    <Form.Label>Applicable %</Form.Label>
                    <Form.Control
                      type="number"
                      step="0.01"
                      min="0"
                      max="100"
                      onInput={(e) => {
                        if (e.target.value > 100) e.target.value = 100;
                        if (e.target.value < 0) e.target.value = 0;
                      }}
                      {...register("Nom1_App_Percent", {
                        required: "Applicable % is required",
                        validate: (value) =>
                          value <= 100 || "Applicable % cannot exceed 100",
                      })}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="Nom1_MobileNo">
                    <Form.Label>Mobile No</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("Nom1_MobileNo", { required: "Mobile No is required" })}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 2: Email, Address 1, Address 2, City */}
              <Row className="mb-3">
                <Col md={3}>
                  <Form.Group controlId="Nom1_Email">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      {...register("Nom1_Email", { required: "Email is required" })}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="Nom1_Add1">
                    <Form.Label>Address 1</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("Nom1_Add1", { required: "Address is required" })}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="Nom1_Add2">
                    <Form.Label>Address 2</Form.Label>
                    <Form.Control type="text" {...register("Nom1_Add2")} />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="Nom1_City">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("Nom1_City", { required: "City is required" })}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Row 3: Pincode, Country, ID Type, ID Number */}
              <Row className="mb-3">
                <Col md={3}>
                  <Form.Group controlId="Nom1_Pincode">
                    <Form.Label>Pincode</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("Nom1_Pincode", { required: "Pincode is required" })}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="Nom1_Country">
                    <Form.Label>Country</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("Nom1_Country", { required: "Country is required" })}
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="Nom1_IdType">
                    <Form.Label>ID Type</Form.Label>
                    <Form.Control
                      as="select"
                      {...register("Nom1_IdType", { required: "ID Type is required" })}
                    >
                      <option value="">Select</option>
                      <option value="PAN">PAN Card</option>
                      <option value="Aadhar">Aadhar Card</option>
                      <option value="DL">Driving Licence</option>
                      <option value="Passport">Passport</option>
                    </Form.Control>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group controlId="Nom1_IdNo">
                    <Form.Label>ID Number</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("Nom1_IdNo", { required: "ID Number is required" })}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Modal.Footer className="border-0">
                <Button variant="secondary" onClick={onSkip}>
                  Skip
                </Button>
                <Button variant="success" type="submit">
                  Save Nominee
                </Button>
              </Modal.Footer>
            </>
          )}
        </Form>
      </Modal.Body>
    </Modal>

  );
};

export default NomineeDetailsDraft;
